import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoadingItem } from 'src/app/modules/shared/interfaces/loading-item';
import { LoadingService } from 'src/app/modules/shared/services/loading.service';
import { SEOService } from 'src/app/modules/shared/services/seo.service';
import { CatalogService } from '../../services/catalog.service';
import {PrerenderService} from "../../../../services/prerender.service";
import Swal from 'sweetalert2';
import { MailerService } from 'src/app/modules/shared/services/mailer.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DemService } from 'src/app/modules/shared/services/dem.service';
import { ProjectService } from 'src/app/modules/shared/services/project.service';
import { IRemoteProfile } from 'src/app/modules/shared/interfaces/iremote-profile';

@Component({
  selector: 'catalog-player',
  templateUrl: './catalog-player.component.html',
  styleUrls: ['./catalog-player.component.scss']
})
export class CatalogPlayerComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<any> = new Subject();
  public catalogId: string;
  public agencyCode: string;
  public networkId: string | number;
  public location: string;

  public catalogName: string;
  public catalogImage: string;

  public iframeSrc: any;
  private resizeObservable$: Observable<Event>;

  public catalogModuleURI = {
    PROD: 'https://www.offertetouroperator.com/oto3/deployment/back/zeus-catalog-creator-module/player/',
    PRE: 'https://lamp-pre.offertetouroperator.com/projects/zeus/zeus-catalog-creator-module/player/',
    DEV: 'https://lamp-dev.offertetouroperator.com/projects/zeus/zeus-catalog-creator-module/player/',
    LOCAL: 'http://localhost:4351/player/'
  };

  public apiKey = 'eba9b9ee-e63b-4ae8-a3b2-26315e8908eb';

  // TEST CATALOG 643e57961760ad7999edc48e

  @ViewChild('player') player: ElementRef;

  @ViewChild('formEmail') formEmail: ElementRef;
  public isAccordionOpen = false;

  private readonly messengerId: string = 'm-catalog-oto-fe';
  private readonly playerId: string = 'm-catalog-player';

  private resizeDebounceTime: number = 300;
  private isIframeReady: boolean;
  private isLanding: boolean;
  private isShowingActiveContent: boolean;
  private timeoutIDs: ReturnType<typeof setTimeout>[] = [];
  //ublic isSocialLink: boolean;
  private loader: LoadingItem;

  public isPrerender: boolean;
  public uaDebug;

  @HostListener('window:message', ['$event']) onPostMessage(event: any) {
    this.processMessage(event);
  }

  public email;
  public shareEmail = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  public profile:IRemoteProfile;

  constructor(
    private _route: ActivatedRoute,
    private _domSantizer: DomSanitizer,
    private _loadingService: LoadingService,
    private _seoService: SEOService,
    private _catalogService: CatalogService,
    private _prerenderService: PrerenderService,
    private _mailerService: MailerService,
    private router: Router,
    private meta: Meta,
    private _demService: DemService,
    private _projectService: ProjectService,
   ) {
    this.uaDebug =  window.navigator.userAgent.toLowerCase();
  }

  ngOnInit(): void {
    this.isPrerender = this._prerenderService.isPrerender;
    this.loader = {id: 'catalog-player', message: 'Caricamento catalogo in corso . . .'};
    this._loadingService.addLoad(this.loader);
    // TODO REFACTOR ENV
    // https://localhost:4350/cataloghi/player/643e57961760ad7999edc48e?network=46&code=1025
    this._route.paramMap.pipe(takeUntil(this._destroy$)).subscribe(params => {
      this.catalogId = params.get('id');

      this.getCatalogAndSetMetaTags(this.catalogId);
      this.isLanding = window.location.pathname.toLowerCase().includes("/landing");
      const queryParams = this._route.snapshot.queryParams;
      this.networkId = queryParams.network ? queryParams.network : null;
      this.agencyCode = queryParams.code ? queryParams.code : null;
      //this.isSocialLink = queryParams.social != undefined;

      // FB share fix url from facebook - temp
      if (this.agencyCode && this.agencyCode.includes(';')) {
        this.agencyCode = this.agencyCode.substring(this.agencyCode.indexOf(';'), 0);
      }
      const pagePos = queryParams.page ? queryParams.page : null;
      const sectionPos = queryParams.section ? queryParams.section : null;

      const uri = `${this.catalogModuleURI.PROD}${this.apiKey}/${this.catalogId}?isPDFcreator=false${this.agencyCode ? '&code=' + this.agencyCode : ''}${this.networkId ? '&network=' + this.networkId : ''}${pagePos ? '&page=' + pagePos : ''}${sectionPos ? '&section=' + sectionPos : ''}`;
      this.iframeSrc = this._domSantizer.bypassSecurityTrustResourceUrl(uri);

      this.resizeObservable$ = fromEvent(window, 'resize');
      this.resizeObservable$.pipe(debounceTime(this.resizeDebounceTime),distinctUntilChanged(),takeUntil(this._destroy$)).subscribe(e =>
        {
          if (this.isIframeReady) {
            if (this.isShowingActiveContent) {
              this.requestContentHeight();
            } else {
              this.calculateAndSetHeight(this.isLanding);
            }

          }
        }
       );

    });


    this._projectService.getProfile().pipe(takeUntil(this._destroy$)).subscribe(res => {
      this.profile = res
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
    this.timeoutIDs.forEach(id => clearTimeout(id));
  }

  private processMessage(postMessage: any): void {
    if (postMessage.data.key === this.playerId) {
      if (postMessage.data.hasOwnProperty('ready')) {
        window.scroll(0, 0);
        this.sendHelloMessage();
        this.calculateAndSetHeight(this.isLanding);
        this.isIframeReady = true;
        this.isShowingActiveContent = false;
      }
      if (postMessage.data.hasOwnProperty('contentHeight')) {
        this.isShowingActiveContent = true;
        this.player.nativeElement.style.height = postMessage.data.contentHeight + "px";
      }
      if (postMessage.data.hasOwnProperty('isLoaded')) {
        this._loadingService.removeLoad(this.loader);
      }
      if (postMessage.data.hasOwnProperty('metaData')) {
        let meta = postMessage.data.metaData;
        this.location = this.createLocationLink(location.href);
        meta.url = this.location;
        this._seoService.setOpenGraphTags(meta.title, meta.description, meta.image, meta.url);
      }
    }
  }

  private createLocationLink(location: string): string {
    if(location.includes('lamiagenziaviaggi')){
      location = location.replace('/landing', '');
    }
    let newLocation = location.includes('?') ? location + ('&social=true') : location + ('?social=true');
    return encodeURIComponent(newLocation);
  }

  private sendMessage(message: any): void {
    if (this.player?.nativeElement?.contentWindow) {
      this.player.nativeElement.contentWindow.postMessage(message, '*');
    } else {
      this.timeoutIDs.push(setTimeout(()=> this.sendMessage(message), 250));
    }
  }

  private sendHelloMessage(): void {
    const message = {
      key: this.messengerId,
      message: "Hello from OTO-FE"
    }
    this.sendMessage(message);
  }

  private sendHeight(height: number, isPortrait: boolean): void {
    const message = {
      key: this.messengerId,
      height: height,
      isPortrait : isPortrait
    };
    this.sendMessage(message);
  }

  private requestContentHeight(): void {
    const message = {
      key: this.messengerId,
      requestContentHeight: true,
    };
    this.sendMessage(message);
  }

  private calculateAndSetHeight(isLanding: boolean): void {
    let header;
    let footer;
    let topBar;
    if (isLanding) {
      header = document.querySelector('.c-landing__header');
      footer = document.querySelector('.c-landing__footer');
    } else {
      header = document.querySelector('app-nav-bar');
      topBar = document.querySelector('app-top-bar')
      footer = document.querySelector('footer');
    }

    const headerHeight = header.getBoundingClientRect().height + (topBar ? topBar.getBoundingClientRect().height : 0);
    const footerHeight = footer.getBoundingClientRect().height;


    const aspect = window.innerWidth / window.innerHeight;
    const maxAspect = 1.1;
    const isPortrait = aspect < maxAspect;


    const playerHeight = (window.innerHeight - headerHeight);

    this.player.nativeElement.style.height = playerHeight + "px";
    this.sendHeight(playerHeight, isPortrait);
  }

  private getCatalogAndSetMetaTags(catalogId): void {
    this._catalogService.getCatalogByIdAndApiKey(catalogId, this.apiKey, true).then(
      (catalog) => {
        this.location = this.createLocationLink(location.href);
        let url = this.location;
        this.catalogName = catalog.name;
        this.catalogImage = catalog.pages[0].sections[0].content.image.url;
        let description;
        if (catalog.style_rules.page_css_class == 'wtg') {
          description = "Sfoglia il catalogo per scegliere la tua prossima vacanza. Un universo di esperienze incredibili ti aspetta!";
        } else if (catalog.style_rules.page_css_class == 'geo') {
          description = "Una ricca proposta di vacanze, sfoglia il catalogo e scegli quella che fa per te!";
        }
        this._seoService.setOpenGraphTags(this.catalogName, description, this.catalogImage, url);
        if (this.isPrerender) this._loadingService.removeLoad(this.loader);
        const metasToCheck = {
          title: this.catalogName,
          description: description,
          image: this.catalogImage,
          url:url,
        }

        this._prerenderService.handleMetaLoadedAndCreateElement(metasToCheck);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public showCatalog(): void {
    // Facebook sharing workaround
    //this.isSocialLink = false;
    this._loadingService.addLoad(this.loader);
    this.timeoutIDs.push(setTimeout(()=> this._loadingService.removeLoad(this.loader), 5250));
  }

  public senderMail() {
    let templateDataObject = {
      link: decodeURIComponent(this.location),
      ogTitle : this.meta.getTag('property="og:title"').content,
      ogImg : this.meta.getTag('property="og:image"').content,
      ogDescription : this.meta.getTag('property="og:description"').content,
      logoLink : this.profile.logo,
      email : this.profile.email_1 ?? this.profile.email_2,
      address : this.profile.indirizzo,
      naming: this.profile.denominazione,
      city: this.profile.citta,
    }

    let template;
    this.getTemplateEmail().then(res => {
      template = template = this._demService.replaceShareEmail( res , templateDataObject);
      this._mailerService.sendEmail({
        from: "test",
        to: this.shareEmail.get("email").value,
        body: template,
        title: `${templateDataObject.ogTitle}`,
      }).toPromise().then(()=> {
        Swal.fire({
          showConfirmButton: false,
          title: "Email inviata con successo!",
          icon: "success",
          timer: 2000,
        });
        this.isAccordionOpen = false
        this.shareEmail.reset();
      })
    })
  }

  public toggleAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen;
  }

  async getTemplateEmail() {
    const layoutNetwork = this.profile.network_owner === "16" ? "wtgCatalogMail" : "geoCatalogMail";
    let template;
    await this._demService.getLayout(layoutNetwork).then(res => {
      template = res;
    })
    return template
  }
}
